

import styled from "styled-components"
import { NumericFormat } from 'react-number-format';


const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        /* transform: translateY(-22px); */
    }

    label{
        position: absolute;
        /* transform: ${({value}) => value && "translateY(-22px)"}; */
        bottom: 32px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }
`

const InputPhoneNew = ({data, setData, isRequired, name, labelText, inputWidth}) => {

    const handleChange = (event) => {
        const text = event.target.value;

        const phoneRegex = /^[1-9]\d{0,9}$/;
    
        if (phoneRegex.test(text)) {
            setData(text);
        }
    };
    
  return (
    <Container onClick={(e) => e.stopPropagation()}  value={data} radius={"5px"} inputWidth={inputWidth}>
        {/* <PhoneInput name={name} onChange={setData} value={data} country={"tr"} countryCodeEditable={false} /> */}
        <NumericFormat type="text" id={"text"} onChange={handleChange} value={data || ""} name={name}/>
        <label htmlFor={"text"}>{labelText}{isRequired && "*"} </label>
    </Container>
  )
}

export default InputPhoneNew